import { Component, OnInit, Input } from '@angular/core';
import { AppComponent } from 'app/app.component';

@Component({
  selector: 'menu-profile',
  templateUrl: './menu-profile.component.html',
  styleUrls: ['./menu-profile.component.scss']
})
export class MenuProfileComponent implements OnInit {

  appComponent:AppComponent;


  constructor(app:AppComponent) { 
    this.appComponent = app;

  }

  ngOnInit() {
  }

  setTheme(cor:string){
    console.log(cor);
  }

}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/menu-profile/menu-profile.component.ts